module.exports = __webpack_public_path__ + "static/audio/beep.68fccd4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/beep.mp3
// module id = 362
// module chunks = 2